import React from 'react';

function BlogSection({ blogs, visibleBlogs, loading, loadMoreBlogs, setSelectedBlog }) {
  
  // Magic Line: Blog guloke display_order hisebe sajiye nichchi (0, 1, 2...)
  const sortedBlogs = [...blogs].sort((a, b) => (a.display_order || 0) - (b.display_order || 0));

  return (
    <section id="blogs" className="py-24 px-6 md:px-16 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <header className="text-center mb-16">
          <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal">Insights & Wisdom</span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-4 text-deep-charcoal">From the Therapy Room</h2>
        </header>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-ocean-teal"></div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
              {/* Ekhane ebar blogs er bodole sortedBlogs use korlam */}
              {sortedBlogs.slice(0, visibleBlogs).map((blog) => (
                <article 
                  key={blog.id} 
                  className="group cursor-pointer flex flex-col h-full outline-none focus-visible:ring-4 focus-visible:ring-ocean-teal/20 rounded-[2.5rem]" 
                  onClick={() => setSelectedBlog(blog)}
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && setSelectedBlog(blog)}
                >
                  <div className="overflow-hidden rounded-[2.5rem] mb-6 shadow-sm border border-gray-100 relative">
                    <img 
                      src={blog.image_url || 'https://via.placeholder.com/800x600'} 
                      alt={blog.title} 
                      className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700 ease-out" 
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-deep-charcoal/0 group-hover:bg-deep-charcoal/10 transition-colors duration-500"></div>
                  </div>
                  <div className="space-y-3 px-2 flex-grow flex flex-col">
                    <h3 className="text-2xl font-serif font-bold group-hover:text-ocean-teal transition-colors leading-snug line-clamp-2">{blog.title}</h3>
                    <p className="text-deep-charcoal/60 text-sm line-clamp-3 leading-relaxed flex-grow">{blog.excerpt}</p>
                    <div className="pt-4 text-xs font-black uppercase tracking-[0.2em] text-ocean-teal/60 group-hover:text-ocean-teal transition-all flex items-center gap-2">
                      Read Article <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {visibleBlogs < blogs.length && (
              <div className="mt-20 text-center">
                <button 
                  onClick={loadMoreBlogs}
                  className="px-10 py-4 bg-white border-2 border-ocean-teal/30 text-ocean-teal font-black uppercase tracking-[0.2em] text-xs rounded-full hover:bg-ocean-teal hover:text-white hover:border-transparent transition-all shadow-sm hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-ocean-teal/20"
                >
                  Load More Articles
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}

export default BlogSection;